export var IImageTile;
(function (IImageTile) {
    let IImageTileStyle;
    (function (IImageTileStyle) {
        /**
         * Return an instance of IImageTileStyle with the provided fields. Any field not
         * listed will be populated with an empty value (an empty array,
         * or undefined, whichever is valid for the type of the value.)
         */
        IImageTileStyle.build = (partial) => (Object.assign({ animation_on_hover: [] }, (partial !== null && partial !== void 0 ? partial : {})));
    })(IImageTileStyle = IImageTile.IImageTileStyle || (IImageTile.IImageTileStyle = {}));
    let ImageTileVariant;
    (function (ImageTileVariant) {
        ImageTileVariant["IMAGE_TILE_VARIANT_UNKNOWN"] = "IMAGE_TILE_VARIANT_UNKNOWN";
        /**
         * Used when the image is rectangular aspect ratio is 1:1
         */
        ImageTileVariant["SQUARE_TILE"] = "SQUARE_TILE";
        /**
         * Used when the image is circular with default size
         */
        ImageTileVariant["CIRCLE_TILE"] = "CIRCLE_TILE";
        /**
         * Used when the image is circular with small size
         */
        ImageTileVariant["SMALL_CIRCLE_TILE"] = "SMALL_CIRCLE_TILE";
        /**
         * Used when the image is rectangular with aspect ratio 3:4
         */
        ImageTileVariant["PORTRAIT_TILE"] = "PORTRAIT_TILE";
        /**
         * Used when the image is rectangular with aspect ratio 4:3
         */
        ImageTileVariant["LANDSCAPE_TILE"] = "LANDSCAPE_TILE";
    })(ImageTileVariant = IImageTile.ImageTileVariant || (IImageTile.ImageTileVariant = {}));
    let ImageTileAnimation;
    (function (ImageTileAnimation) {
        ImageTileAnimation["IMAGE_TILE_ANIMATION_UNKNOWN"] = "IMAGE_TILE_ANIMATION_UNKNOWN";
        ImageTileAnimation["ZOOM"] = "ZOOM";
        ImageTileAnimation["UNDERLINE"] = "UNDERLINE";
    })(ImageTileAnimation = IImageTile.ImageTileAnimation || (IImageTile.ImageTileAnimation = {}));
    /**
     * Return an instance of IImageTile with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    IImageTile.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(IImageTile || (IImageTile = {}));
